<mds-dialog dialogTitle="Delete Form">
    <mds-dialog-content>
        <div class="o-grid__row">
            <div class="o-grid__item">
                <span>Are you sure you want to delete this file?</span>
            </div>
        </div>
    </mds-dialog-content>
    <mds-dialog-actions [align]="'end'">
        <div class="flex flex-row gap-medpace">
            <mds-button [id]="'cancel-btn'" label="Cancel" (clickEvent)="closeDialog()" variant="outline"></mds-button>
            <mds-button
                [id]="'confirm-btn'"
                label="Confirm"
                (clickEvent)="submitDelete()"
                [color]="'primary'"
                [variant]="'filled'"
            ></mds-button>
        </div>
    </mds-dialog-actions>
</mds-dialog>
